<dgx-modal
  [useDefaultSubmitButton]="false"
  [isHeaderBorderless]="false"
  [canCancel]="true"
>
  <!-- Modal Header -->
  <ng-container class="modal-header">
    <span [textContent]="i18n.BusinessRules_AddSegments"></span>
  </ng-container>

  <!-- Modal Body -->
  <ng-container class="modal-body">
    <div class="guts-p-full-1" [ngSwitch]="maximumSegmentsReached">
      <df-local-notification
        *ngSwitchCase="true"
        [type]="NotificationType.warning"
        [text]="i18n.SkillStd_MaximumAddedSegmentsReached"
        size="small"
      ></df-local-notification>
      <df-local-notification
        *ngSwitchDefault
        [type]="NotificationType.info"
        [text]="i18n.SkillStd_MaximumAddedSegmentsDesc"
        size="small"
      ></df-local-notification>
    </div>
    <dgx-rules-search
      class="grid__col-12"
      [orgId]="orgId"
      [label]="i18n.BusinessRules_SelectSegment"
      [ruleType]="ruleType"
      [ngDisabled]="maximumSegmentsReached"
      [disabledRules]="existingAndPendingSegments"
      (addRule)="add($event)"
    ></dgx-rules-search>
    <div class="grid__col-12 guts-p-t-0" *ngIf="pendingSegments.length">
      <label [textContent]="i18n.TargetResourcesForm_Selected"></label>
      <ul>
        <li
          *ngFor="let segment of pendingSegments; trackBy: trackById"
          data-dgat="add-existing-segments-to-skill-standards-modal-2b5"
        >
          <div class="l_flexbar border-bottom">
            <div class="l_flex-grow">
              <div class="l_flexbar guts-p-v-1 guts-p-h-0">
                <div
                  class="l_flex-grow break par--small"
                  [innerHtml]="displaySegmentNameAndAttributes(segment)"
                ></div>
              </div>
            </div>
            <div>
              <button
                type="button"
                class="guts-p-full-1 dg-modal__close-icon"
                (click)="remove(segment)"
                [ngbTooltip]="i18n.Core_Remove"
                tooltip-trigger="'focus mouseenter'"
                [attr.aria-label]="i18n.Core_Remove"
                data-dgat="add-existing-segments-to-skill-standards-modal-334"
              >
                <df-icon icon="cross"></df-icon>
              </button>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="grid__col-12">
      <button
        *ngIf="allowManageSegments"
        type="button"
        class="color-blue par par--small font-semibold left-text"
        [class.is_disabled]="maximumSegmentsReached"
        [disabled]="maximumSegmentsReached"
        (click)="createNewSegment()"
        data-dgat="add-existing-segments-to-skill-standards-modal-3df"
      >
        <div class="l_flexbar gap-full-half">
          <df-icon icon="plus"></df-icon>
          <div>{{ 'BusinessRules_CreateASegment' | translate }}</div>
        </div>
      </button>
    </div>
  </ng-container>

  <!-- Modal Footer -->
  <ng-container class="modal-footer">
    <button
      *ngIf="allowManageSegments"
      type="button"
      class="color-blue par par--small font-semibold guts-m-r-1"
      (click)="openManageSegmentsPage()"
      data-dgat="add-existing-segments-to-skill-standards-modal-92b"
    >
      <span> {{ i18n.BusinessRules_ManageSegments }} </span>
    </button>
    <button
      type="button"
      df-button
      dfButtonType="primary"
      [ngClass]="{ is_disabled: saving || pendingSegments.length === 0 }"
      [disabled]="saving || pendingSegments.length === 0"
      [textContent]="saving ? i18n.Core_Saving : i18n.Core_Add"
      (click)="save()"
      data-dgat="add-existing-segments-to-skill-standards-modal-a33"
    ></button>
  </ng-container>
</dgx-modal>
